import {toast} from "../../html-elements/toast";
import {post} from "../../functions";
import {standardResponse} from "../../messages";

export function initLogin() {
    document.querySelector('form').addEventListener('submit', function () {
        if (this.validateForm()) {
            post('api/login/login', this).then(resp => {
            console.log(resp);
                if (resp.status !== '200') {
                    toast(resp.payload.message, 'error');
                    return;
                }
                location.reload();
            })
        } else {
            standardResponse('000');
        }
    })
}